<template>
    <div id="confirmation" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                </div>
                <div class="modal-body">
                    <p v-html="message"></p>
                </div>
                <div class="modal-footer text-center">
                    <button type="button" class="btn btn-success" @click="onConfirm(true)" data-dismiss="modal">Yes</button>
                    <button type="button" class="btn btn-secondary" @click="onConfirm(false)" data-dismiss="modal">No</button>
                </div>
            </div>
        </div>
    </div>       
</template>

<script>
export default {
    data() {
        return {
            title: 'Confirm',
            message: null,
            callback: null,
            args: null
        }
    },
    methods: {
        show: function (title, message, callback, ...args) {
            this.title = title,
            this.message = message;
            this.callback = callback;
            this.args = args;
            $('#confirmation').modal('show');
        },
        onConfirm: function (value) {

            this.callback ? this.callback(value, ...this.args) : this.$emit('callback', value, ...this.args);
        }
    },
    created() {
        eventHub.$on('show-confirmation', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-confirmation');
    }
}
</script>

<style scoped>

</style>